export const DONATION_INFO_TEXT = {
  title: 'Please don\'t go yet!',
  extraProductTitle: 'Please don\'t leave!',
  title1: 'Wait! We want to contribute on your behalf!',
  description: (name, mindonation, currencyIcon) => `Just ${currencyIcon}${mindonation} can give ${name} a shot at surviving this life-threatening disease and your contribution can make this possible`,
  description1: (name) => `Download the Ketto App. We’ll support ${name} in your name.`,
  non_med_desc: (name) => `<div>${name}, can really use your help right now.</div> <div>Even a small contribution from you could make a significant impact.</div>`,
  extraProductDescription: () => `Life is difficult for them but a single contribution from you will help them go on.`
};
